// Map content-model icon strings to Lucide React components.
import {
    Compass, Workflow, GraduationCap, Sparkles, Network, LineChart,
    GitBranch, Repeat, ShieldCheck, Database, ServerCog, Users, Scale, Activity,
    Search, Map, Bot, PenSquare,
    BookMarked, Brain, FileText,
    BookOpen, Building2, HeartPulse, Layers,
    ClipboardCheck, Briefcase, Route, Globe2,
    MessageCircle, Mail, ArrowRight, ArrowUpRight, Calendar, Menu, X,
    HelpCircle,
} from "lucide-react";

const MAP = {
    "compass": Compass,
    "workflow": Workflow,
    "graduation-cap": GraduationCap,
    "sparkles": Sparkles,
    "network": Network,
    "line-chart": LineChart,
    "git-branch": GitBranch,
    "repeat": Repeat,
    "shield-check": ShieldCheck,
    "database": Database,
    "server-cog": ServerCog,
    "users": Users,
    "scale": Scale,
    "activity": Activity,
    "search": Search,
    "map": Map,
    "bot": Bot,
    "pen-square": PenSquare,
    "book-marked": BookMarked,
    "brain": Brain,
    "file-text": FileText,
    "book-open": BookOpen,
    "building-2": Building2,
    "heart-pulse": HeartPulse,
    "layers": Layers,
    "clipboard-check": ClipboardCheck,
    "briefcase": Briefcase,
    "route": Route,
    "globe-2": Globe2,
    "message-circle": MessageCircle,
    "mail": Mail,
    "arrow-right": ArrowRight,
    "arrow-up-right": ArrowUpRight,
    "calendar": Calendar,
    "menu": Menu,
    "x": X,
};

export const ICON_OPTIONS = Object.keys(MAP);

export const iconFor = (name) => MAP[name] || HelpCircle;
